import React from "react";
import { Route, Routes } from "react-router-dom";
import { RouteWithAuth } from "src/Modules/Auth/RouteWithAuth/RouteWithAuth";
import { useAuth0 } from "src/hooks/useAuth";
import { useAppContext } from "src/context/AppContext";
import { Loading } from "../components/Loading";
import { IRoute, ROUTES_SUPPORTING_PERMISSIONS } from "./RouteConfig";
import { routes as routeConsts } from "./RouteConstants";

interface IProps {
  routes: IRoute[];
}

const AppRoutes = (props: IProps) => {
  const {
    context: {
      featureFlags: { openChangeRequests },
    },
  } = useAppContext();
  const { isLoading } = useAuth0();
  const { routes } = props;
  if (isLoading) {
    return <Loading />;
  }

  const filteredRoutes = openChangeRequests
    ? routes
    : routes.filter(
        (route) =>
          ![
            routeConsts.changes,
            routeConsts.changeRequest,
            routeConsts.removeSupply,
          ].includes(route.path)
      );

  return (
    <Routes>
      {filteredRoutes.map((route) => {
        if (ROUTES_SUPPORTING_PERMISSIONS.includes(route.type)) {
          return (
            <Route
              path={route.path}
              element={<RouteWithAuth route={route} />}
              key={`auth-${route.path}`}
            />
          );
        } else {
          return (
            <Route
              path={route.path}
              element={<route.component />}
              key={`route-${route.path}`}
            />
          );
        }
      })}
    </Routes>
  );
};

export default AppRoutes;
